import { initAdLandingTracking } from '@common/utils/adLanding'
import { initAssetMonitor } from '@common/utils/assetMonitor'
import { setupAxiosErrorHandler } from '@common/utils/axiosErrorHandler'
import { disableDoubleSubmit } from '@pc/components/DisableDoubleSubmit'
import { clickEvent, clickUxCv } from '@pc/components/EventTrack'
import { headerLoginWindow } from '@pc/components/HeaderLoginWindow'
import { initPageTop } from '@pc/components/PageTop'
import { smoothScrollHandler } from '@pc/components/SmoothScrollHandler'

// 静的アセット読み込みエラーの監視（defer 実行で即時。PerformanceObserver の buffered:true で初期ロード分も拾う）
initAssetMonitor()

// グローバル axios へのエラーハンドラ登録（defer 実行で即時）
setupAxiosErrorHandler()

document.addEventListener('DOMContentLoaded', () => {
  // Ad経由ユーザーのトラッキング・キャッシュ分離
  initAdLandingTracking()

  // ヘッダーのログイン情報入力ウィンドウ
  headerLoginWindow()

  // クリックイベント計測用
  clickEvent()

  // UX CV のクリックイベント計測用
  clickUxCv()

  // スムーズスクロール
  smoothScrollHandler()

  // 「ページトップへ」ボタン
  initPageTop()

  // 二重submit防止
  disableDoubleSubmit()
})
